/**
 * Slice 49 — the running job's start time, shown above the step strip on every step.
 * The job pages set it; the shared step header reads it. No prop threading through 14 step screens.
 */
import { useSyncExternalStore } from "react";

export interface ActiveJobClock {
  startedAt: string | null;
  /** True when the start stamp has no location (shown once, on the first step). */
  locationNotSaved: boolean;
}

const EMPTY: ActiveJobClock = { startedAt: null, locationNotSaved: false };
let current: ActiveJobClock = EMPTY;
const listeners = new Set<() => void>();

export function setActiveJobClock(next: ActiveJobClock | null) {
  const value = next ?? EMPTY;
  if (value.startedAt === current.startedAt && value.locationNotSaved === current.locationNotSaved) return;
  current = value;
  listeners.forEach((l) => l());
}

export function useActiveJobClock(): ActiveJobClock {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => {
        listeners.delete(cb);
      };
    },
    () => current,
    () => EMPTY,
  );
}
